import React from 'react';
import './style.css'
import { SlEnvolope } from "react-icons/sl";
import { Link } from 'react-router-dom';

const TableView = ({ data, headings }) => {

    return (
        <div className='campaign-table-view'>
            <table className='campaign-table'>
                <thead>
                    <tr>
                        {Object.keys(headings).map((key) => (
                            <th key={key}>{headings[key]}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((campaign, index) => (
                        <tr key={index}>
                            {Object.entries(campaign).map(([key, value]) => {
                                return <td key={key}>{value}</td>;
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableView;
